import styled from "styled-components";

export const Container = styled.div`
  margin: 25px auto 30px;

  > div {
    margin-right: 5px;
  }
`;